import { Model } from "@/models/base/model";

export class ExerciseHabit extends Model {
  private baseUrl = "/cms/api/my-record/exercise-habit"; // ベースURL
  // コンストラクタ
  constructor(params: any = {}) {
    super(params);
    this.url = this.baseUrl;
  }

  // 運動習慣選択肢を取得
  async getExerciseHabits(): Promise<any> {
    this.url = `${this.baseUrl}/get-exercise-habits`;
    return await super.fetch();
  }

  // ユーザーの運動習慣を取得
  async getUserExerciseHabit(): Promise<any> {
    this.url = `${this.baseUrl}/get-user-exercise-habit`;
    return await super.fetch();
  }

  // 保存処理
  async save(exerciseRoutineOptionId: number): Promise<any> {
    this.url = `${this.baseUrl}/save`;
    return await super.save({ exerciseRoutineOptionId }, "POST");
  }
}
